/**
 * Copyright 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export enum ScheduleType {
  recurring = "recurring",
  specifiedDates = "specifiedDates",
  onDemand = "onDemand",
}
